import { useState } from "react";
import { EntityManager } from "@/components/EntityManager";
import { FDImporter } from "@/components/FDImporter";
import { ENTITY_CONFIG } from "@/lib/entities";

export default function FixedDeposits() {
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="space-y-6">
      <FDImporter onPosted={() => setReloadKey((k) => k + 1)} />
      <EntityManager key={reloadKey} config={ENTITY_CONFIG.fixedDeposits} />
    </div>
  );
}
